import { render, staticRenderFns } from "./chain-sub.vue?vue&type=template&id=7b68ac3f&scoped=true&"
import script from "./chain-sub.vue?vue&type=script&lang=js&"
export * from "./chain-sub.vue?vue&type=script&lang=js&"
import style0 from "./chain-sub.vue?vue&type=style&index=0&id=7b68ac3f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b68ac3f",
  null
  
)

export default component.exports